export default __webpack_public_path__ + "static/media/628.003ecf31.gif";